<template>
  <div class="content">
    <div class="allContent">
      <div class="header">
      <h2>已累计签到<i>{{this.signInFrom.signTotal}}</i>天</h2>
      <div class="step">
        <van-steps
          :active="active"
          active-icon="checked"
          size="14px"
          active-color="#0f6aff"
          inactive-color="#cccccc"
          click-step="gitPoints"
        >
          <van-step></van-step>
          <van-step
            ><van-icon
              name="gift"
              size="22px"
              :class="[active >= 1 ? 'change' : '']"
              @click.native="on_click(1)"
          /></van-step>
          <van-step
            ><van-icon
              name="gift"
              size="22px"
              :class="[active >= 2 ? 'change' : '']"
              @click.native="on_click(2)"
          /></van-step>
          <van-step
            ><van-icon
              name="gift"
              size="22px"
              :class="[active == 3 ? 'change' : '']"
              @click.native="on_click(3)"
          /></van-step>
        </van-steps>
        <van-row>
          <van-col span="4">累计</van-col>
          <van-col span="8">7天</van-col>
          <van-col span="8">15天</van-col>
          <van-col span="4">25天</van-col>
        </van-row>
      </div>
      <div class="header_b">
        <span class="left">本轮奖励时间: {{this.signInFrom.monthStr}}</span>
        <span class="right" @click="signin"><a>签到</a></span>
      </div>
      <div class="record" @click="getIntegralRecord">积分记录</div>
      <div class="prizerecord" @click="goPrizeRecord">我的奖品</div>
      </div>
      <div class="main">
      <h1><i>每日任务</i></h1>
      <ul>
        <li v-if="this.systemOS() == true">
          <img src="@/assets/youxi@3x.png" alt="" />
          <div class="mask">
            <p>每日玩游戏+4</p>
            <p>完成{{this.signInFrom.playGameTotal>= 2 ? 2 : this.signInFrom.playGameTotal}}/2</p>
          </div>
          <div class="btn">
            <button @click.prevent="goplay" :class="[this.signInFrom.playGameTotal>= 2 ? 'changeBtn':'']">{{this.signInFrom.playGameTotal>= 2 ? '已完成':'去完成'}}</button>
          </div>
        </li>
        <li>
          <img src="@/assets/liulan@3x.png" alt="" />
          <div class="mask">
            <p>每日浏览一件商品+1</p>
            <p>完成{{this.signInFrom.browseCommodityTotal >= 1 ? 1 : 0}}/1</p>
          </div>
          <div class="btn">
            <button @click.prevent="gobrowse" :class="[this.signInFrom.browseCommodityTotal>= 1 ? 'changeBtn':'']">{{this.signInFrom.browseCommodityTotal >= 1 ? '已完成':'去完成'}}</button>
          </div>
        </li>
        <li>
          <img src="@/assets/liulan@3x.png" alt="" />
          <div class="mask">
            <p>每日浏览五件商品+3</p>
            <p>完成{{this.signInFrom.browseCommodityTotal >= 5 ? 5 : this.signInFrom.browseCommodityTotal}}/5</p>
          </div>
          <div class="btn">
            <button @click.prevent="gobrowse" :class="[this.signInFrom.browseCommodityTotal>= 5 ? 'changeBtn':'']">{{this.signInFrom.browseCommodityTotal >= 5 ? '已完成':'去完成'}}</button>
          </div>
        </li>
        <li>
          <img src="@/assets/liulan@3x.png" alt="" />
          <div class="mask">
            <p>每日浏览十件商品+5</p>
            <p>完成{{this.signInFrom.browseCommodityTotal >= 10 ? 10 : this.signInFrom.browseCommodityTotal}}/10</p>
          </div>
          <div class="btn">
            <button @click.prevent="gobrowse" :class="[this.signInFrom.browseCommodityTotal>= 10 ? 'changeBtn':'']">{{this.signInFrom.browseCommodityTotal >= 10 ? '已完成':'去完成'}}</button>
          </div>
        </li>
        <li v-if="this.systemOS() == true">
          <img src="@/assets/fenxiang@3x.png" alt="" />
          <div class="mask">
            <p>每日一次APP分享+3</p>
            <p>完成{{ this.signInFrom.shareTotal >= 1 ? 1 : 0 }}/1</p>
          </div>
          <div class="btn">
            <button @click.prevent="goshare" :class="[this.signInFrom.shareTotal >= 1 ? 'changeBtn':'']">{{this.signInFrom.shareTotal >= 1 ? '已完成':'去完成'}}</button>
          </div>
        </li>
      </ul>
      </div>
    </div>
    <div id="lotteryMask" class="bgMask">
      <img id="closebox" src="@/assets/img_off@3x.png" alt="" @click="openBox">
      <img id="openbox" src="@/assets/img_on@3x.png" alt="">
      <img id="refuse" src="@/assets/refuseprize.png" alt="" @click="closeMask">
    </div>
  </div>
</template>

<script>
import { Step, Steps, Icon, Col, Row, Toast, Dialog, Progress } from "vant";
import { wxRequest } from "@/api/user";

export default {
  data() {
    return {
      active: 0,
      requestForm: {
        id: "",
        phone: "",
        code: "",
      },
      signInFrom: '',
      lottery: '',
      // 签到接口参数
      signpost: {
        signTime: "",
        id: "",
        phone: "",
        key: "",
      },

    };
  },
  methods: {
    // 判断系统
    // 判断当前系统
    systemOS() {
      let u = navigator.userAgent;
      let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      if (isAndroid) {
        return true;
      }
      if (isIOS) {
        return false;
      }
    },

    getSignInfo() {
      localStorage.setItem("id", this.requestForm.id);
      localStorage.setItem("phone", this.requestForm.phone);
      wxRequest("xxtx/app/sign/task/info", this.requestForm, "post").then (res => {
        if(res.data.code == 200) {
          this.signInFrom = res.data.data.signTimeInfo
          this.signInFrom.monthStr = this.signInFrom.monthStr.replace(/\./g,'/');
          this.signInFrom.monthStr = this.signInFrom.monthStr.slice(this.signInFrom.monthStr.indexOf('-')+1,this.signInFrom.monthStr.length)
          this.lottery = res.data.data.isLottery
          this.stepController();
          
          // 签到显示
          var signInText = document.querySelector('.header_b .right');
          if (this.signInFrom.isSignTime == 1) {
            signInText.textContent = '已签到'
            signInText.style.color = '#666666'
          }
          else {
            signInText.textContent = '签到';
          }

          // 抽奖显示
          if (this.lottery.isLottery == 1) {
            var lotteryMask = document.getElementById('lotteryMask');
            lotteryMask.style.display = 'none';
          }
        }
        else {
          this.$notify({type:'danger',message: res.data.message});
        }
      })
    },
    on_click(val) {
      this.$notify({type:'warning',message: '系统已自动为您领取'});
    },
    getIntegralRecord() {
      this.$router.push({
        path: "/integralRecord",
      });
    },
    goPrizeRecord() {
      this.$router.push({
        path: "/goExchange",
        query: {
          phone: this.requestForm.phone,
          id: this.requestForm.id,
        },
      });
    },

    // 签到步骤条控制
    stepController() {
      if (!this.signInFrom.signTotal && this.signInFrom.signTotal < 7) {
        this.active = 0;
      } else if (this.signInFrom.signTotal >= 7 && this.signInFrom.signTotal < 15) {
        this.active = 1;
      } else if (
        this.signInFrom.signTotal >= 15 &&
        this.signInFrom.signTotal < 25
      ) {
        this.active = 2;
      } else if (this.signInFrom.signTotal == 25) {
        this.active = 3;
      } else {
        this.active = 0;
      }
    },

    // 点击签到
    signin() {
      var content = document.querySelector('.header_b .right');
      if(content.textContent == '签到') {
        //签到接口
        //获取签到所需的key
        this.signpost.id = this.requestForm.id;
        this.signpost.phone = this.requestForm.phone;
        wxRequest("xxtx/app/key", this.signpost, "post").then((res) => {
          if (res.data.code == "200") {
            this.signpost.key = this.$md5(
              res.data.data + this.requestForm.phone
            ).toUpperCase();
            this.signpost.signTime = this.getNowFormatDate();
            wxRequest("xxtx/app/sign", this.signpost, "post").then((res) => {
              if (res.data.code == "200") {
                this.$notify({type:'success',message: res.data.data});
                //重新获取页面数据
                this.getSignInfo();
              } else {
                this.$notify({type:'warning',message: res.data.data});
              }
            });
          } else {
            Toast.fail(res.data.result);
          }
        });
      }
      else {
        this.$notify({type:'success',message: '你已签到'});
      }
    },

    //获取当前时间，格式YYYY-MM-DD
    getNowFormatDate() {
      var date = new Date();
      var seperator1 = "-";
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate;
      return currentdate;
    },

    goplay() {
      window.location.href = "xxtx://play_game";
    },
    gobrowse() {
      if (this.systemOS() == false) {
        window.location.href = "http://goto_shopping";
      } else if (this.systemOS() == true) {
        window.location.href = "xxtx://goto_shopping";
      }
    },
    goshare() {
      window.location.href = "xxtx://share_app";
    },

    // 开宝箱
    openBox() {
      let closeBox = document.getElementById('closebox');
      let openBox = document.getElementById('openbox')
      closeBox.style.display = 'none';
      openBox.style.display = 'inline-block';
      this.$router.push({
        path: "/luckywheel",
        query: {
          phone: this.requestForm.phone,
          id: this.requestForm.id,
        },
      });
    },

    closeMask() {
      lotteryMask.style.display = 'none';
    },

    // 提取当前url参数
    getUrl() {
      var search = window.location.hash;
      this.requestForm.phone = getSearchString("phone", search);
      this.requestForm.id = getSearchString("id", search);
      // key需要检索的键 url需要分割的url地址(问号及之后的)
      function getSearchString(key, Url) {
        var str = Url;
        str = str.substring(12, str.length);
        console.log(str)
        var arr = str.split("&");
        var obj = new Object();
        for (var i = 0; i < arr.length; i++) {
          var tmp_arr = arr[i].split("=");
          obj[decodeURIComponent(tmp_arr[0])] = decodeURIComponent(tmp_arr[1]);
        }
        return obj[key];
      }
    }
  },
  created() {
    //获取当前路径
    this.getUrl();
    this.getSignInfo();
  },
};
</script>

<style lang="less">
.van-steps {
  background-color: transparent !important;
  .van-step__circle-container {
    background-color: transparent !important;
  }
  .van-steps--horizontal {
    padding: 10px 26px;
  }
}
.van-step__line {
  background-color: #ffffff !important;
  height: 4px !important;
}

.van-step__line:first-child {
  background-color: #ffffff !important;
  height: 4px !important;
  border-top-left-radius: 2px !important;
  border-bottom-left-radius: 2px !important;
}

.van-step__circle-container {
  top: 32px !important;
}

.van-step__circle {
  width: 10px;
  height: 10px;
  border: 1px solid #ffffff;
  background-color: #0f6aff;
}

.van-row {
  padding: 0 6px !important;
  color: #ffffff;
}

.van-row .van-col--8 {
  text-align: center !important;
  padding-left: 1.0625rem !important;
}

.van-row .van-col--4 {
  text-align: left !important;
}

.van-row .van-col--4:last-child {
  text-align: right !important;
}

.change {
  color: #ffffff;
}

.van-step__title {
  margin-left: 6px !important;
}

.van-icon-checked::before {
  content: "\F02F";
  opacity: 1;
  font-size: 12px;
  padding: 1px;
  background-color: #fff;
  border-radius: 50%;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
    Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif;
}

.header {
  width: 100%;
  height: 18.75rem;
  background: linear-gradient(to bottom, #3e7dea, #1e49d3);
  h2 {
    padding: 1.875rem 0 1.875rem 1rem;
    color: #ffffff;
    font-size: 24px;
  }
  .header_b {
    position: relative;
    margin-top: 2.125rem;
    padding-left: 1rem;
    color: #ffffff;
    .right {
      position: absolute;
      padding: 0.5rem 2rem;
      background: #ffffff;
      border-radius: 1rem;
      top: -0.5rem;
      right: 1.25rem;
      font-size: 18px;
      font-weight: 700;
      color: #0647b2;
      a {
        color: #1e49d3;
      }
    }
  }
  .record,
  .prizerecord {
    position: absolute;
    width: 70px;
    height: 28px;
    background-color: rgba(255, 255, 255, 0.2);
    right: 0;
    text-align: center;
    line-height: 28px;
    border-radius: 13px 0 0 13px;
    font-size: 12px;
    color: #fff;
  }
  .record {
    top: 1.25rem;
  }
  .prizerecord {
    top: 3.6rem;
  }
}
.main {
  margin: 0 20px;
  margin-top: -4rem;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  background-color: #fff;
  h1 {
    padding: 1rem 0 1rem 1rem;
    font-size: 18px;
    font-weight: 550;
    i {
      padding-bottom: 4px;
      border-bottom: 2px solid orange;
    }
  }
  ul {
    display: flex;
    display: -webkit-flex;
    flex-direction: column;
    padding: 0 10px;
    li {
      box-sizing: border-box;
      height: 60px;
      line-height: 60px;
      border-bottom: 1px solid #ccc;
      img {
        float: left;
        width: 30px;
        height: 30px;
        padding: 15px;
      }
      .mask {
        float: left;
        height: 60px;
        p {
          height: 30px;
          line-height: 30px;
          font-size: 14px;
        }
        p:nth-child(1) {
          height: 22px;
          padding-top: 8px;
          font-weight: 700;
        }
        p:nth-child(2) {
          color: #7d7d7d;
        }
      }
      .btn {
        float: right;
        width: 70px;
        button {
          border: none;
          background-color: transparent;
          outline: none;
          border: 1px solid #327fff;
          padding: 0.375rem 0.75rem;
          border-radius: 0.875rem;
          color: #327fff;
          font-size: 12px;
        }
        .changeBtn {
          border: 1px solid #666666;
          color: #666666;
        }
      }
    }
    li:last-child {
      border-bottom: none;
    }
  }
}
.bgMask {
  // display:none;
  position:fixed;
  top:0%;left:0%;width:100%;height:100%;
  // background-color:black;
  background: rgba(0, 0, 0, 0.6);
  z-index:1001;
  // opacity: 0.5;           /* 支持opacity的浏览器*/
  // filter:alpha(opacity=60);       /* IE 兼容性IE11*/
  // -moz-opacity:0.5;              /* 老版Mozilla */
  text-align: center;
  padding-top: 56%;
  img {
    z-index: 10;
    width: 200px;
  }
  #openbox{
    display: none;
    width: 200px;
  }
  #refuse{
    position: absolute;
    top: 24%;
    right: 20%;
    width: 28px;
    height: 28px;
  }
}
</style>
